import axios from '@/axios';
import coreIAMUrl from '@/apis/coreIAM'

export default {
    fetchAll() {
        return axios.get(`${coreIAMUrl}/roles`)
    },
    fetchOne(uuid) {
        return axios.get(`${coreIAMUrl}/roles/${uuid}`);
    },
    createRole(name, description) {
        return axios.post(`${coreIAMUrl}/roles`, {
            name: name,
            description: description
        });
    },
    updateRole(roleUuid, name, description) {
        return axios.patch(`${coreIAMUrl}/roles/${roleUuid}`, {
            name: name,
            description: description,
        });
    },
    deleteRole(roleUuid) {
        return axios.delete(`${coreIAMUrl}/roles/${roleUuid}`);
    },
}
